import React, { FC } from "react";

import { Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";
import { LabelTextItem } from "ui-library/modules";

import i18n from "core/i18n";

interface RecapitulationProps {
    validityStartDate: Date;
    isOperatorEdited: boolean;
    isOwnerEdited: boolean;
}

export const Recapitulation: FC<RecapitulationProps> = ({ validityStartDate, isOperatorEdited, isOwnerEdited }) => {
    const { t } = i18n.useTranslation();

    return (
        <>
            <ContentBox fullWidth textAlign={"center"}>
                <Typography variant="h3">{t("vehicle.change.subject.signature.changelist")}</Typography>
            </ContentBox>

            <ContentBox fullWidth>
                {isOperatorEdited && (
                    <LabelTextItem
                        label={t("person.operator")}
                        text={`${t("vehicle.change.subject.signature.operatorChange")} ${validityStartDate?.toLocaleDateString()}`}
                    />
                )}

                {isOwnerEdited && (
                    <LabelTextItem
                        label={t("person.operator")}
                        text={`${t("vehicle.change.subject.signature.ownerChange")} ${validityStartDate?.toLocaleDateString()}`}
                    />
                )}
            </ContentBox>
        </>
    );
};
